import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import KozosCsoportLista from './KozosCsoportLista';
import BufeKinalat from './BufeKinalat';
import BufeLista from './BufeLista';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../BufeTooltips';

class TermekekBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: undefined,
    };
  }

  componentDidMount() {
    this.initTab();
  }

  initTab = () => {
    let tabs = [
      this.props.globals.hasRole(['BUFE_KOZOS']),
      this.props.globals.hasRole(['BUFE_KINALAT']),
      this.props.globals.hasRole(['BUFE_BUFE'])
    ];

    let firstIndex = tabs.findIndex(x=> x === true) + 1;  

    this.setState({ activeTab: firstIndex.toString() });
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  hasRole = (roles) => {
    return this.props.globals.hasRole(roles);
  }

  hasRoleSpec = (roles) => {
    return this.props.globals.hasRoleSpec(roles);
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Termékek
              {/* <YouTube data={videoData} /> */}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.hasRole(['BUFE_KOZOS']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Közös lista
                        <CustomTooltip text={getTooltip('kozoslista')} id="kozoslistaTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.hasRole(['BUFE_KINALAT']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Termék lista
                        <CustomTooltip text={getTooltip('termeklista')} id="termeklistaTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.hasRole(['BUFE_BUFE']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => { this.toggle('3'); }}
                      >
                        Büfék
                        <CustomTooltip text={getTooltip('bufek')} id="bufekTT" />
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.hasRole(['BUFE_KOZOS']) && (
                    <TabPane tabId="1">
                      <KozosCsoportLista {...this.props} globals={this.props.globals} active={this.state.activeTab === '1'} />
                    </TabPane>
                  )}
                  {this.hasRole(['BUFE_KINALAT']) && (
                    <TabPane tabId="2">
                      <BufeKinalat {...this.props} globals={this.props.globals} active={this.state.activeTab === '2'} key={this.state.activeTab} />
                    </TabPane>
                  )}
                  {this.hasRole(['BUFE_BUFE']) && (
                    <TabPane tabId="3">
                      <BufeLista {...this.props} globals={this.props.globals} active={this.state.activeTab === '3'} />
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TermekekBase.propTypes = {
  globals: PropTypes.object
};

export default TermekekBase;
